import api from "@/services/api"

// initial state
const state = { leftMenu: {}, filters: {} }

const getters = {}

const mutations = {
  SET_LEFT_MENU: (state, payload) => (state.leftMenu = payload),
  SET_FILTER: (state, payload) => (state.filters[payload.name] = payload.value)
}

const actions = {
  getLeftMenu({ commit }) {
    return new Promise((resolve, reject) => {
      api.getSchema("menu").then(response => {
        commit("SET_LEFT_MENU", response.items)
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
